import Transactions from '../modules/Transactions/transaction.table';
import MarketStats from '../components/MarketStats/MarketStats';
import { useState } from 'react';
import SyntheticsTable from '../modules/Synthetics/synthetics.table';
import CommonMenu from '../components/commonMenu/commonMenu';
import { Helmet } from 'react-helmet-async';
export default function Home() {
  const [searchToken, setSearchToken] = useState('');

  return (
    <>
      <Helmet>
        <title>{`HootDex : A Decentralised Digital Asset Swapping System`}</title>
        <link rel="icon" href={'/favicon.png'} type="image" />
      </Helmet>
      <div
        className="screen"
        style={{
          zIndex: '100',
          position: 'sticky',
          width: '100%',
          marginBottom: '1rem'
        }}
      >
        <div
          style={{
            width: '95%',
            minWidth: '340px',
            margin: '0 auto 1rem auto'
          }}
        >
          <MarketStats />
        </div>

        <div
          style={{
            width: '95%',
            minWidth: '340px'
          }}
          className="res-token"
        >
          <CommonMenu label={'SynthCryptos'} setSearch={setSearchToken} />
          <SyntheticsTable searchToken={searchToken} />
          <Transactions />
        </div>
      </div>
    </>
  );
}
